import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "windSpeed",
  "use": "windSpeed-usage",
  "viewBox": "0 0 20 18.42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18.42\" id=\"windSpeed\"><title>windSpeed</title><path d=\"M13.2 12.21H.58a.58.58 0 0 0 0 1.16H13.2a1.93 1.93 0 1 1-1.76 2.71.58.58 0 0 0-1.06.47 3.09 3.09 0 1 0 2.82-4.34zm3.16-9.7a3.64 3.64 0 0 0-3.53 2.76.582.582 0 1 0 1.13.28 2.48 2.48 0 1 1 2.41 3.08H.58a.58.58 0 0 0 0 1.16h15.78a3.645 3.645 0 0 0 0-7.29zM.58 6.21h7.7a3.09 3.09 0 1 0-2.82-4.38.58.58 0 1 0 1.06.47 1.93 1.93 0 1 1 1.76 2.71H.58a.6.6 0 1 0 0 1.2zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/windSpeed.svg
// module id = ttwx
// module chunks = 6